import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const Header: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <h1 className="text-xl font-bold text-gray-900">锁期记录</h1>
          
          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-600">
              欢迎，{user?.username}
              {user?.role === 'admin' && (
                <span className="ml-2 px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full">
                  管理员
                </span>
              )}
            </span>
            <button
              onClick={logout}
              className="text-sm text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded"
            >
              退出登录
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;